import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { FormsPage } from "@/features/forms/FormsPage";

const search = z.object({
  status: z.enum(["all", "live", "draft", "closed"]).optional(),
  peek: z.string().optional(),
});

export const Route = createFileRoute("/_app/forms/")({
  validateSearch: search,
  component: () => <FormsPage search={Route.useSearch()} />,
});
